export enum WarningPanelType {
  Close = 1,
  Open = 2
}
